import { useContext } from 'react';
import './style.scss';
import { ReactComponent as Close } from '../../st-close.svg';
import { FormDataContext } from '../FormDataProvider';

function ClosePopup(props) {

  const { closeForm } = useContext(FormDataContext);



  return (
    <div className="close-popup">
        <div className="close-popup-modal">
            <div className="close-btn" onClick={() =>props.changeShowPopup(false)}>
                <Close />
            </div>
            <h3>Är du säker på att du vill lämna?</h3>
            <p>Informationen som du har fyllt i kommer inte att sparas.</p>
            <div className="close-popup-modal-buttons">
                <div className="close-popup-modal-buttons-btn" onClick={(e) => {closeForm(); props.changeShowPopup(false);}}><a href="#">Ja</a></div>
                <div className="close-popup-modal-buttons-btn" onClick={() =>props.changeShowPopup(false)}><a href="#">Nej</a></div>
            </div>
        </div>
    </div>
  );
}

export default ClosePopup;
